import {
  Comission_Get as comission,
  Comission_GetAsCsv as csvExport,
} from './portal'

const getComission = async (page, pageSize, filters) => {
  let toExtended = new Date(filters.to)
  toExtended.setHours(toExtended.getHours() + 24)
  let {data} = await comission({
    page: page,
    pageSize: pageSize,
    from: filters.from,
    to: toExtended,
  })
  return data
}

const getDateAsString = date => {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [year, month, day].join('-')
}

const getComissionAsCsv = async filters => {
  let toExtended = new Date(filters.to)
  toExtended.setHours(toExtended.getHours() + 24)
  let {data} = await csvExport({
    from: filters.from,
    to: toExtended,
  })
  if (data) {
    exportCsv(
      data,
      `Provision_${getDateAsString(filters.from)}_${getDateAsString(
        filters.to,
      )}`,
    )
  }
}

const exportCsv = (content, fn) => {
  const encodedUri = encodeURI('data:text/csv;charset=utf-8,\uFEFF' + content)
  let link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', fn + '.csv')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export default {
  getComission,
  getComissionAsCsv,
}
